
export const TERMINALS_ACTION_TYPES = {
   GET_TERMINALS_INFO_DATA: 'GET_TERMINALS_INFO_DATA',
   GET_TERMINALS_DATA_INFO_DATA_DONE: 'GET_TERMINALS_DATA_INFO_DATA_DONE',
   POST_TERMINAL_DATA: 'POST_TERMINAL_DATA',
   POST_TERMINAL_DATA_DONE: 'POST_TERMINAL_DATA_DONE',
   DELETE_TERMINAL_DATA: 'DELETE_TERMINAL_DATA',
   DELETE_TERMINAL_DATA_DONE: 'DELETE_TERMINAL_DATA_DONE',
   GET_TERMINAL_DATA_BY_ID: 'GET_TERMINAL_BY_ID_DATA',
   GET_TERMINAL_DATA_BY_ID_DONE: 'GET_TERMINAL_BY_ID__DATA_DONE',
   GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA: 'GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA',
   GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA_DONE: 'GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA_DONE',
   PUT_TERMINALS_INFO_DATA: 'PUT_TERMINALS_INFO_DATA',
   PUT_TERMINALS_INFO_DATA_DONE: 'PUT_TERMINALS_INFO_DATA_DONE',
};

export const getTerminalsInfoDataAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINALS_INFO_DATA,
   payload: req,
});

export const getTerminalsInfoDataActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINALS_DATA_INFO_DATA_DONE,
   payload: req,
});

export const deleteTerminalDataAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.DELETE_TERMINAL_DATA,
   payload: req,
});

export const deleteTerminalDataActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.DELETE_TERMINAL_DATA_DONE,
   payload: req,
});

export const postTerminalDataAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.POST_TERMINAL_DATA,
   payload: req,
});

export const postTerminalDataActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.POST_TERMINAL_DATA_DONE,
   payload: req,
});

export const getTerminalDataByIdAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINAL_DATA_BY_ID,
   payload: req,
});

export const getTerminalDataByIdActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINAL_DATA_BY_ID_DONE,
   payload: req,
});

export const getTerminalsPreferencesLocationProductsDataAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA,
   payload: req,
});

export const getTerminalsPreferencesLocationProductsDataActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA_DONE,
   payload: req,
});

export const putTerminalDataAction = (req) => ({
   type: TERMINALS_ACTION_TYPES.PUT_TERMINALS_INFO_DATA,
   payload: req,
});

export const putTerminalDataActionDone = (req) => ({
   type: TERMINALS_ACTION_TYPES.PUT_TERMINALS_INFO_DATA_DONE,
   payload: req,
});


export default {
   TERMINALS_ACTION_TYPES,
   getTerminalsInfoDataAction,
   getTerminalsInfoDataActionDone,
   deleteTerminalDataAction,
   deleteTerminalDataActionDone,
   postTerminalDataAction,
   postTerminalDataActionDone,
   getTerminalDataByIdAction,
   getTerminalDataByIdActionDone,
   getTerminalsPreferencesLocationProductsDataAction,
   getTerminalsPreferencesLocationProductsDataActionDone,
   putTerminalDataAction,
   putTerminalDataActionDone
}